import type { SustainabilityStatsItem } from '@/types/sustainability';

export function parseCommunityStatNumber(stat: SustainabilityStatsItem): number {
  const raw = `${stat.statValue ?? ''}`.replace(/,/g, '').trim();
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getCommunityStatSuffix(stat: SustainabilityStatsItem): string {
  return stat.statSuffix?.trim() ?? '';
}
